@if (label) {
  <label [for]="id" [ngClass]="{ required: required }" class="mb-1 text-sm font-medium">{{ label | translate }}</label>
}
<div>
  <ng-content></ng-content>
  <div class="p-error" style="min-height: 14px; font-size: 0.75rem">{{ error }}&nbsp;</div>
</div>
